export const classNames = (...classes: (string | undefined | null)[]): string =>
  classes.filter(Boolean).join(" ");

export const prettyPrint = <T, K extends keyof T>(obj: T, key: K): string =>
  JSON.stringify(obj[key], null, 2);
